<template>
    <v-container>
      <v-card class="pa-5">
        <v-card-title>Gerador de UUIDs para QR Codes</v-card-title>
  
        <v-card-text>
          <v-text-field
            v-model="quantity"
            label="Quantidade de UUIDs"
            type="number"
          ></v-text-field>
  
          <v-btn @click="generateUUIDs">Gerar UUIDs</v-btn>
  
          <v-textarea
            v-model="output"
            label="UUIDs gerados"
            :rows="10"
            auto-grow
          ></v-textarea>
        </v-card-text>
      </v-card>
      <Snackbar ref=chamaSnackbar />
    </v-container>
  </template>
  
  <script>
  import { v4 as uuidv4 } from 'uuid';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  
  export default {
    components: { Snackbar },
    data() {
      return {
        quantity: 1,
        output: "",
      };
    },
    methods: {
    async generateUUIDs() {
      const generated = [];

      for (let i = 0; i < this.quantity; i++) {
        const uuid = uuidv4();
        const codigoAbreviado = uuid.slice(-6);

        const uuidObject = {
          qrcode: `https://aiconsumer.intelite.com.br/?cf=${uuid}`,
          situacao: "LIVRE",
          created: new Date().toISOString(),
          codigoAbreviado: codigoAbreviado
        };

        // Adiciona ao array
        generated.push(uuidObject);

        // Faz a chamada POST para a API
        try {
          const response = await axios.post(baseApiUrl + 'QRCodes?access_token=' + sessionStorage.getItem('accToken'), uuidObject);
          if (response.data) {
            // Aqui eu não tenho certeza de qual "atributo" você se refere,
            // mas vou considerar como um valor no data do Vue.
            // Se não for, substitua conforme sua necessidade.
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1","Operação realizada com Sucesso!","INFORMAÇÃO")
          }
        } catch (error) {
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao realizar operação","DESCULPE")
        }
      }

      // Atualiza o output com os objetos gerados
      this.output += JSON.stringify(generated, null, 2);
    },
  },
  };
  </script>
  
  <style scoped>
  /* (mesmo estilo que forneci anteriormente, ou outros que você desejar) */
  </style>
  